import { useTenantStore } from '$hooks/services/useTenants'
import { title } from '@genie-fintech/ui/style/typography'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { ChevronsUpDown, Layers, Settings, UserCog2 } from 'lucide-react'
import { content, line, quickActionItem, trigger } from './styles.css'
import { flexColumn } from '$styles/common.css'
import { themeVars } from '@genie-fintech/ui/style/theme'
import { Radio } from '@genie-fintech/ui/components'
import { redirect, ROUTE_NAMES } from '$router/config'
import { useCallback } from 'react'
import { MainSidebarMenu } from '$layouts/PageLayout/SidebarMenuItem/constants'
import { useRouteSummary } from '$contexts/RouteContext/hooks'

const { colors } = themeVars

const quickActions = [
  {
    name: 'Create Application',
    Icon: Layers,
    to: ROUTE_NAMES.CREATE_APP
  },
  {
    name: 'Add member',
    Icon: UserCog2,
    to: ROUTE_NAMES.GLOBAL_MEMBER_CREATE
  },
  {
    name: 'Settings',
    Icon: Settings,
    to: ROUTE_NAMES.PASSWORD_POLICY
  }
]

const TenantSwitcher = () => {
  const {
    route: { name: routeName }
  } = useRouteSummary()

  const { id, name } = useTenantStore(state => state.currentTenant) ?? {}
  const tenants = useTenantStore(state => state.tenants)

  const onChangeTenant = useCallback(
    (tenantId: string) => {
      if (!routeName) return

      const { to = ROUTE_NAMES.TENANT_STATISTICS } =
        MainSidebarMenu.find(menu =>
          [menu.to, ...menu.subPath].includes(routeName)
        ) ?? {}

      redirect(to, ({ params, ...options }) => ({
        ...options,
        params: { ...params, tenantId }
      }))
    },
    [routeName]
  )

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <article className={trigger}>
          <p className={title.six}>{name}</p>
          <ChevronsUpDown size={16} />
        </article>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className={content}>
          <DropdownMenu.Item
            className={flexColumn}
            style={{ padding: 16, gap: 8 }}
          >
            <p className={title.three} style={{ color: colors.neutral[60] }}>
              SWITCH IdP
            </p>

            <Radio.Group
              asChild
              style={{
                display: 'grid',
                gap: 8
              }}
              value={id}
              onValueChange={onChangeTenant}
            >
              <main>
                {tenants.map(tenant => (
                  <Radio.Item
                    key={tenant.id}
                    label={tenant.name}
                    value={tenant.id}
                    styleVariants={{ bordered: true, padded: true }}
                  />
                ))}
              </main>
            </Radio.Group>
          </DropdownMenu.Item>

          <hr className={line} />

          <article className={flexColumn} style={{ padding: 8, gap: 8 }}>
            {quickActions.map(({ name, Icon, to }) => (
              <DropdownMenu.Item
                key={name}
                onClick={() => redirect(to, options => options)}
                className={quickActionItem}
              >
                <Icon size={16} />
                <p className={title.six}>{name}</p>
              </DropdownMenu.Item>
            ))}
          </article>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

export default TenantSwitcher
